export default __webpack_public_path__ + "swoosh-c13e87535cd52964ef6cfa2d726e33c0.mp3";